/* theme.js — interactivity: cart drawer, menu, gallery, variants, search */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const routes = window.routes || {};

  /* ---------- Cart drawer ---------- */
  const drawer = $('#CartDrawer');
  const cartCounts = $$('[data-cart-count]');

  function openDrawer() { drawer && drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer && drawer.classList.remove('is-open'); document.body.style.overflow = ''; }

  async function refreshCart() {
    try {
      const res = await fetch(routes.cart_url + '?section_id=cart-drawer-content');
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('#CartDrawerContent');
      const target = $('#CartDrawerContent');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
      const cart = await (await fetch(routes.cart_url + '.js')).json();
      updateCount(cart.item_count);
      bindLineItems();
    } catch (e) { console.error(e); }
  }

  function updateCount(n) {
    cartCounts.forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  async function addToCart(form) {
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = 'Adding…'; btn.disabled = true; }
    try {
      const res = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: new FormData(form)
      });
      if (!res.ok) throw new Error('add failed');
      await refreshCart();
      openDrawer();
    } catch (e) {
      window.location = '/cart';
    } finally {
      if (btn) { btn.innerHTML = original; btn.disabled = false; }
    }
  }

  async function changeQty(key, qty) {
    try {
      const res = await fetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await res.json();
      await refreshCart();
    } catch (e) { console.error(e); }
  }

  function bindLineItems() {
    $$('[data-qty-btn]').forEach((b) => {
      b.addEventListener('click', () => {
        const key = b.dataset.key;
        const input = $(`[data-qty-input="${key}"]`);
        let v = parseInt(input.value, 10) || 1;
        v = b.dataset.qtyBtn === 'plus' ? v + 1 : Math.max(0, v - 1);
        changeQty(key, v);
      });
    });
    $$('[data-remove]').forEach((r) => {
      r.addEventListener('click', (e) => { e.preventDefault(); changeQty(r.dataset.remove, 0); });
    });
  }

  // Delegate add-to-cart forms
  $$('form[action$="/cart/add"], form[data-cart-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      if (form.dataset.noAjax) return;
      e.preventDefault();
      addToCart(form);
    });
  });

  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  bindLineItems();

  /* ---------- Mobile nav ---------- */
  const mnav = $('#MobileNav');
  $$('[data-mobile-open]').forEach((b) => b.addEventListener('click', () => { mnav && mnav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
  $$('[data-mobile-close]').forEach((b) => b.addEventListener('click', () => { mnav && mnav.classList.remove('is-open'); document.body.style.overflow = ''; }));

  /* ---------- Esc closes overlays ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeDrawer(); mnav && mnav.classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  /* ---------- Quick add buttons on cards ---------- */
  $$('[data-quick-add]').forEach((b) => {
    b.addEventListener('click', async (e) => {
      e.preventDefault();
      const id = b.dataset.quickAdd;
      if (!id) { window.location = b.dataset.url; return; }
      const fd = new FormData(); fd.append('id', id); fd.append('quantity', 1);
      b.disabled = true;
      try {
        await fetch(routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd });
        await refreshCart(); openDrawer();
      } catch (err) { window.location = '/cart'; } finally { b.disabled = false; }
    });
  });

  /* ---------- Product gallery ---------- */
  $$('[data-thumb]').forEach((t) => {
    t.addEventListener('click', () => {
      const main = $('#ProductMainImage');
      if (main) main.src = t.dataset.full;
      $$('[data-thumb]').forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
    });
  });

  /* ---------- Variant selection ---------- */
  const variantForm = $('[data-variant-form]');
  if (variantForm) {
    const variantsData = JSON.parse($('#VariantData') ? $('#VariantData').textContent : '[]');
    const idInput = variantForm.querySelector('[name="id"]');
    const priceEl = $('#ProductPrice');
    const compareEl = $('#ProductCompare');
    const addBtn = variantForm.querySelector('[type="submit"]');

    function selected() {
      return $$('[data-variant-option]', variantForm).reduce((acc, group) => {
        const checked = group.querySelector('input:checked');
        if (checked) acc.push(checked.value);
        return acc;
      }, []);
    }
    function update() {
      const opts = selected();
      const match = variantsData.find((v) => opts.every((o, i) => v.options[i] === o));
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = window.Gear.formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = window.Gear.formatMoney(match.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.querySelector('[data-add-text]').textContent = match.available ? addBtn.dataset.add : addBtn.dataset.soldout;
      }
    }
    $$('[data-variant-option] input', variantForm).forEach((i) => i.addEventListener('change', update));
    update();
  }

  /* ---------- Quantity inputs (product page) ---------- */
  $$('[data-product-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => {
      let v = parseInt(input.value, 10) || 1;
      v = b.dataset.dir === 'plus' ? v + 1 : Math.max(1, v - 1);
      input.value = v;
    }));
  });

  /* ---------- Predictive search ---------- */
  const searchInput = $('[data-predictive]');
  const searchResults = $('#PredictiveResults');
  if (searchInput && searchResults && routes.predictive_search_url) {
    let timer;
    searchInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; searchResults.hidden = true; return; }
      timer = setTimeout(async () => {
        try {
          const res = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5&section_id=predictive-search`);
          const text = await res.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('#PredictiveResults');
          searchResults.innerHTML = fresh ? fresh.innerHTML : '';
          searchResults.hidden = false;
        } catch (e) { /* noop */ }
      }, 220);
    });
    document.addEventListener('click', (e) => {
      if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) searchResults.hidden = true;
    });
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('reveal'); io.unobserve(en.target); } });
    }, { threshold: 0.08 });
    $$('[data-reveal]').forEach((el) => io.observe(el));
  }

  /* ---------- Facet toggle (mobile) ---------- */
  $$('[data-facet-toggle]').forEach((b) => b.addEventListener('click', () => {
    const f = $('#Facets'); if (f) f.classList.toggle('is-open');
  }));
})();
